<div class="steps active-{{ step }}" [ngClass]="{ purchaseless: purchaselessOnboarding }">
  <div class="steps__container" *ngIf="!purchaselessOnboarding">
    <div class="steps__container__top">
      <div class="dot-step-one"></div>
      <div class="separator-step-one"></div>
      <div class="dot-step-two"></div>
      <div class="separator-step-two"></div>
      <div class="dot-step-three"></div>
    </div>
    <div class="steps__container__bottom">
      <p class="step-one">Crear perfil</p>
      <p class="step-two">Revisar cuotas</p>
      <p class="step-three">Pagar</p>
    </div>
  </div>

  <div
    class="steps__container"
    [ngClass]="{ 'two-steps-padding': !!purchaselessOnboarding }"
    *ngIf="!!purchaselessOnboarding"
  >
    <div class="steps__container__top">
      <div class="dot-step-one"></div>
      <div class="separator-step-one"></div>
      <div class="dot-step-two"></div>
    </div>
    <div class="steps__container__bottom">
      <p class="step-one">Ingresar datos</p>
      <p class="step-two">Agregar tarjeta</p>
    </div>
  </div>
</div>
